import React, { useState } from 'react';

import SendIcon from '@mui/icons-material/Send';

import AppTextField from '../../designe/app-text-field/AppTextField';
import { useTranslation } from 'react-i18next';
import AppFile from '../../designe/app-file/AppFile';
import Post from './post/Post';
import ConfirmDialog from '../confirm-dialog/ConfirmDialog';
import AppDialog from '../app-dialog/AppDialog';
import ReplyPost from './reply-post/ReplyPost';
import AppButtonUploadFile from '../../designe/app-button-upload-files/AppButtonUploadFile';
import clsx from 'clsx';
import { useStyles } from './Posts.styles';
import theme from '../../../styles/theme';
import { SvgClass } from '../../../styles/mixins';
import { orderBy } from '../../../utils/array-utils';
import { IPost } from '../../../types/interfaces/post';
import { usePosts } from './usePosts';

interface IPostsProps {
  posts: IPost[];
  editable?: boolean;
  newPostBinding?: { communityId: string } | { pageUserId: string };
  allowNewPost?: boolean;
  allowComment?: boolean;
}

export default function Posts(props: IPostsProps) {
  const {
    posts,
    editable = true,
    newPostBinding,
    allowNewPost = true,
    allowComment = true,
  } = props;
  const { t } = useTranslation();
  const [deletePostId, setDeletePostId] = useState(null);
  const [repliedPostId, setRepliedPostId] = useState(null);
  const { classes } = useStyles(theme);

  const {
    newPost,
    newPostFilesToUpload,
    onPostDelete,
    onSavePost,
    onEditPost,
    onDeleteNewPostFile,
    onUploadNewPostFiles,
  } = usePosts(newPostBinding);

  function onReplyPost(post: IPost) {
    return onSavePost({ ...post, parentId: repliedPostId });
  }

  return (
    <div className={classes.userPostsWrapper}>
      {allowNewPost && newPostBinding && (
        <div className={classes.newPostWrapper}>
          <div className={classes.newPostData}>
            <AppTextField
              label={t('user.newPost')}
              placeholder={t('user.newPost')}
              fullWidth
              multiline
              maxRows={5}
              value={newPost.content}
              onChange={(e) => onEditPost({ content: e.target.value })}
            />

            <AppButtonUploadFile
              onFileInput={(e) => onUploadNewPostFiles(e.target.files)}
            />
            <SendIcon
              onClick={() => onSavePost()}
              className={clsx(
                !newPost.content &&
                  !newPostFilesToUpload.length &&
                  SvgClass.disabled,
              )}
            />
          </div>
          {!!newPostFilesToUpload.length && (
            <div className={classes.uploadedFilesWrapper}>
              {newPostFilesToUpload.map((file) => (
                <AppFile
                  key={file.id}
                  file={file}
                  onDelete={(file) => onDeleteNewPostFile(file.id)}
                />
              ))}
            </div>
          )}
        </div>
      )}
      <div className={classes.userPostsContainer}>
        {orderBy<IPost>(posts, 'createdAt', 'desc').map((post) => (
          <Post
            editable={editable}
            allowComment={allowComment}
            post={post}
            key={post.id}
            onPostReplied={setRepliedPostId}
          />
        ))}
      </div>

      <AppDialog
        open={!!repliedPostId}
        onClose={() => setRepliedPostId(null)}
        title={t('post.replyPost')}>
        <ReplyPost
          onClose={() => setRepliedPostId(null)}
          onSavePost={onReplyPost}
        />
      </AppDialog>

      <ConfirmDialog
        open={!!deletePostId}
        onClose={() => setDeletePostId(null)}
        title={t('common.delete')}
        onSubmit={() => {
          onPostDelete(deletePostId);
          setDeletePostId(null);
        }}>
        {t('common.deleteQuestion')}
      </ConfirmDialog>
    </div>
  );
}
